function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCountry() {
    fetch('/browsing_context_suggestions.json')
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }
    return response.json();
    }).then((json) => {
        const browsingCountry = json.detected_values.country.handle;
        const recurateDefCountry = "US";
        if (browsingCountry && browsingCountry !== recurateDefCountry) {
            const variantArray = document.querySelectorAll(`[data-country=${recurateDefCountry}]`);

            variantArray.forEach(variant => {
                variant.classList.remove('intl-pending');
                variant.classList.add('intl-true', 'intl-mismatch');
                document.querySelector('.rec-variant-local').classList.remove('rec-hidden');

                const addToCartBtns = variant.querySelectorAll('.intl-mismatch .rec-var-actions button');
                      
                if (addToCartBtns.length > 0) {
                    addToCartBtns.forEach((btn) => {
                        btn.disabled = true;
                        btn.classList.add('rec-unavailable');
                        btn.innerText = 'Item Unavailable';
                        
                        //disable modal add-to-cart btn
                        const variantId = btn.dataset.id;
                        const variantBtn = document.querySelector(`[data-id="${variantId}"]`);
                        if (variantBtn) {
                            variantBtn.classList.add('rec-unavailable');
                            variantBtn.disabled = true;
                            variantBtn.innerText = 'Item Unavailable';
                        }
                    });
                }
            })
        }
    });
}

function geoFence(elements, createMessage) {
    const recurateDefCountry = "US"
    const globalDataCookie = getCookie("GlobalE_Data");
    
    if (globalDataCookie) {
        const localizationCookie = JSON.parse(decodeURIComponent(globalDataCookie))
        const currentCountryISOCode = localizationCookie.countryISO;

        if (recurateDefCountry != currentCountryISOCode) {
            elements.forEach(element => {
                const el = document.querySelector(element);
                
                if (el && createMessage) {
                    const p = document.createElement("p");
                    p.innerText = "Sorry, this item is not available in your country!"
                    el.insertAdjacentElement("afterend",  p);
                }

                if (el) el.remove();
            })
        }
    }
    
    //fall back for geofencing
    if (!globalDataCookie && window.location.pathname.includes('revitalized')) {
        setCountry();
    }
}